import React from 'react';
import { useEffect } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import AdminApp from './admin-app';
import CompanyApp from './company-app';

import { ADMIN_USER, PROVINCE_USER, COMPANY_USER, GlobalContext } from './context/GlobalContext';
import LoginPage from './pages/Login';
import ProvinceApp from './province-app';
import Guard from 'components/Guard';
import ForgotPasswordPage from 'pages/ForgotPassword';
import ChangePasswordPage from 'pages/ChangePassword';

const AppRoutes = () => {
    const userRole = parseInt(localStorage.getItem('user_type'));

    const navigateTo = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const currentPath = location.pathname;
        if (currentPath.includes('change-password')) return;
        const token = localStorage.getItem('token');

        if (token && token.length > 10) {
            switch (userRole) {
                case ADMIN_USER:
                    if (!currentPath.includes('admin')) navigateTo('/admin/dashboard');
                    break;
                case PROVINCE_USER:
                    if (!currentPath.includes('province')) navigateTo('/province');
                    break;
                case COMPANY_USER:
                    if (!currentPath.includes('company')) navigateTo('/company');
                    break;
                default:
                    if (!currentPath.includes('login')) navigateTo('/login');
            }
        } else { 
            if (!currentPath.includes('login')) navigateTo('/login');
        }
    }, []);

    return (
        <Routes>
            <Route path='/login' element={<LoginPage />} />
            <Route path='/forgot-password' element={<ForgotPasswordPage />} />
            <Route path='/change-password' element={<ChangePasswordPage />} />
            <Route element={<Guard isRouteAccessible={userRole === ADMIN_USER} />} >
                <Route path='/admin/*' element={<AdminApp />} />
            </Route>
            <Route element={<Guard isRouteAccessible={userRole === PROVINCE_USER} />} >
                <Route path='/province' element={<ProvinceApp />} />
            </Route>
            <Route element={<Guard isRouteAccessible={userRole === COMPANY_USER} />} >
                <Route path='/company' element={<CompanyApp />} />
            </Route>
        </Routes>
    );
};

export default AppRoutes;
